import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './components/Home/Home.vue'
import Films from './components/Films/Films.vue'
import Info from './components/Info/Info.vue'
import Sounds from './components/Sounds/Sounds.vue'
import Categories from "./components/Categories/Categories.vue"


Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      name: 'home',
      component: Home
    },
    {
      path: '/films/:name',
      name: 'films',
      component: Films
    },
    {
      path: '/info/:name',
      name: 'info',
      component: Info
    },
    {
      path: '/sounds/:name',
      name: 'sounds',
      component: Sounds
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories
    }
  ]
});
